module.exports = __webpack_public_path__ + "img/2.47f871b0.png";